import {DNA} from "@dna/react";
import { BorderColorValue,BackgroundColorValue, BorderSizeValue } from "@dna/react-types/src/shared";

export class EmedStyle {
    static EmedBadge =  {
        Glow : {
            BackGroundColour : '#FEF4E5',
            FontColour : '#925D07'
        },
        Success : {
            BackGroundColour : '#EBF8EB',
            FontColour : '#007A00'
        },
        Warning : {
            BackGroundColour : '#F5F5F5',
            FontColour : '#707070'
        },
        standard:{
            BackGroundColour: '#EDEDED',
            FontColour: '#202020'

        },
        caution:'#F5A623',
        critical:'#C53535', 
        NewMed: "#00AC00",
        blue:'#0099FF'
    };
}

export const AppBorderColor: BorderColorValue = "gray-300";
export const AppBackgroundColor: BackgroundColorValue = "gray-100";
export const AppBorderSize: BorderSizeValue = "thin"
